import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

interface CancelPlanModalProps {
  show: boolean;
  onHide: () => void;
  onConfirmCancel: () => void;
  currentSpaces : number;
  hasWaitlistEntries : boolean;
  isWaitlistEnabled: boolean;
}

export default function UserPlanCancellationModal({
  show,
  onHide,
  onConfirmCancel,
  currentSpaces,
  hasWaitlistEntries,
  isWaitlistEnabled
}: CancelPlanModalProps) {

  const [showWarning, setShowWarning] = useState(false);
  useEffect(() => {
    setShowWarning(hasWaitlistEntries && isWaitlistEnabled);
  }, [hasWaitlistEntries, isWaitlistEnabled]);

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to cancel your plan? You will have access until
          the end of the current billing period.
        </p>
        <div>
        {showWarning && (
        <div className="alert alert-warning text-sm mb-4" role="alert">
            You’re releasing {currentSpaces} space
            {currentSpaces > 1 ? "s" : ""}. Parkers on the waitlist will be moved forward.
            If you change your mind, you’ll re-join the back of the waitlist.
        </div>
        )}
        </div>
        <div className="d-flex flex-column gap-3 mt-3">
          <Button variant="danger" onClick={onConfirmCancel}>
            Confirm Cancellation
          </Button>
          <Button variant="outline-secondary" onClick={onHide}>
            Go Back
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
